import { matchPath } from 'react-router'

// 整理menu格式到一维路由数组，供router可用
export const sortToRoute = route => {
  const result = []
  const rl = r => {
    r.forEach(nextr => {
      if (nextr.path) {
        result.push({ path: nextr.path, component: nextr.component, name: nextr.name })
      }
      if (nextr.children && nextr.children.length > 0) {
        rl(nextr.children)
      }
    })
  }
  rl(route)
  return result
}

// 查找路由链路
export const searchRouterLinkList = (route, path) => {
  const result = []
  const c = config => {
    for (let i = 0; i < config.length; i += 1) {
      const r = config[i]
      let k = null
      if (r.children !== undefined) {
        k = c(r.children)
        if (k) {
          result.push(r)
          return r
        }
      }
      if (matchPath(path, r)) {
        result.push(r)
        return r
      }
    }
    return null
  }
  c(route)
  return result.reverse()
}

export default {}
